import { factory, tracksIndex } from './state'

const getters = {
  factory: () => factory,
  beatCode: (state) => {
    const { makeBeatCode } = require('@/etc/beatcode')
    return makeBeatCode(state.settings)
  },
  secPx: (state) => {
    return (
      state.settings.width /
      (state.timeline.endTime - state.timeline.startTime)
    )
  },
  libraryList: (state) => {
    return Object.values(state.library)
  },
  aspect: (state) => {
    return state.settings.aspect
  },
  playerSize(state) {
    const aw = state.settings.aspect.w
    const ah = state.settings.aspect.h
    const ww = 896
    const wh = 512
    let fitH = true
    const a = aw / ah
    if (aw > ah) {
      if (ww / a < wh) fitH = false
    }
    let w = ww
    let h = w / a
    if (fitH) {
      h = wh
      w = h * a
    }
    let pt = (wh - h) / 2
    let pl = (ww - w) / 2
    return { w, h, pt, pl }
  },
  layerTracks: (state) => {
    return Object.keys(state.tracks)
      .filter((uuid) => state.tracks[uuid].type === 'layer')
      .sort((a, b) => state.tracks[b].layer - state.tracks[a].layer)
      .map((uuid) => state.tracks[uuid])
  },
  viewLimit: (state) => {
    const len = state.timeline.length || 0
    const vmax = state.timeline.viewMax || 0
    return Math.max(len, vmax)
  },
  exportRange: (state, getters) => {
    const limit = getters.viewLimit
    const start = Math.max(0, Math.min(state.timeline.exportIn || 0, limit))
    const endRaw = Number.isFinite(state.timeline.exportOut)
      ? state.timeline.exportOut
      : state.timeline.length
    const end = Math.max(start, Math.min(endRaw, limit))
    return { start, end }
  },
  audioTrack: (state) => {
    return state.tracks[tracksIndex.audioTrackUuid]
  },
  autodropTrack: (state) => {
    if (!state.dnd) return ''
    if (state.dnd.dndType === 'strip') return ''
    const base = state.dnd.type.split('/').shift()
    //start simple - audio asset without audio track
    if (base === 'audio') {
      if (
        !Object.keys(state.tracks[tracksIndex.audioTrackUuid].strips).length
      )
        return tracksIndex.audioTrackUuid
    }

    for (let i = 1; i < 5; i++) {
      // track is free
      const tuuid = tracksIndex[`trackUuid${i}`]
      if (!Object.keys(state.tracks[tuuid].strips).length) return tuuid
    }
    // if autodrop not found
    return ''
  },
  activeTrack: (state) => {
    if (!state.timeline.activeTrack) return null
    return state.tracks[state.timeline.activeTrack] || null
  },
  activeStrip: (state, getters) => {
    if (!getters.activeTrack || !state.timeline.activeStrip) return null
    return getters.activeTrack.strips[state.timeline.activeStrip] || null
  },
  activeKeyframe: (state, getters) => {
    if (!state.timeline.activeKeyframe || !state.timeline.activeStrip)
      return null
    return (
      getters.activeStrip.animation.keyframes.find(
        (kf) => kf.uuid === state.timeline.activeKeyframe
      ) || null
    )
  },
  activeAsset: (state, getters) => {
    if (!getters.activeStrip) return null
    return factory.asset(getters.activeStrip.asset.uuid)
  },
}

export default getters

